import { Component, OnInit, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { DialogService } from '../../../shared/services/dialog.service';
import { BookingDetailsPopupComponent } from '../booking-detail/booking-detail.component';
import { BookingDetailsFluVaccinePopupComponent } from '../booking-detail/booking-detail-fluvaccine.component';
import { ManageBookingService } from './manage-booking.service';
import { BookingService } from '../booking.service';
import { BookingStatus } from '../../../models/booking/booking-details.model';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { PartyType } from '../../../models/consultation/cash-sale.model';
import { CalendarModel } from '../../../models/booking/booking-details.model';
import { ComponentCanDeactivate } from '../../../pending-changes.guard';

import * as moment from 'moment';
declare var $j: any;
@Component({
    selector: 'app-booking',
    templateUrl: 'manage-booking.component.html',
    providers: [ManageBookingService, BookingService]
})
export class ManageBookingComponent implements OnInit, AfterViewInit, OnDestroy, ComponentCanDeactivate {
    public timeslot = AppConstants.calendar.timeslot;
    public bookingInfo = new CalendarModel();
    public bookingCacheDetail: any;
    public showBack = false;
    public showDeactiveMessage = true;
    public timeRange;
    public timeout = AppConstants.refreshTime.timeout; // timeout 3 minutes
    public refreshTimeOut;
    constructor(
        public dialogService: DialogService,
        public manageBookingService: ManageBookingService,
        public bookingService: BookingService,
        public utility: Utility,
        private router: Router
    ) { }

    canDeactivate(): Observable<boolean> | boolean {
        if (this.bookingCacheDetail != null && this.showDeactiveMessage !== false) {
            const confirmMessage = AppMessages.bookingCalendar.discardConfirm;
            return this.dialogService.openConfirmationDialog({ message: confirmMessage }).flatMap(
                result => {
                    if (result) {
                        return this.manageBookingService.deleteBookingCache().map(
                            success => {
                                if (success) {
                                    return true;
                                }
                                return false;
                            });
                    } else {
                        return Observable.of(false);
                    }
                });
        } else {
            return true;
        }
    }

    ngOnInit() {
        // set time out to refresh list
        this.setInterval();
        this.bookingService.getBookingCache().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.bookingCacheDetail = data;
                    if (this.bookingCacheDetail != null) {
                        this.showBack = true;
                    }
                }
            }
        );
    }

    clearTimeout() {
        // clear timeout
        if (this.refreshTimeOut) {
            clearInterval(this.refreshTimeOut);
        }
    }

    setInterval() {
        this.refreshTimeOut = setInterval(() => this.refreshList(), this.timeout);
    }

    refreshList() {
        this.manageBookingService.getBookingList(this.timeRange).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    data['bookingList'] = this.filterData(data['bookingList']);
                    this.updateBookingListData(data);
                    $j('#myCalendar').pagescalendar('removeAllEvents');
                    $j('#myCalendar').pagescalendar('addEvents', this.bookingInfo.bookingList);
                }
            }
        );
    }

    ngOnDestroy() {
        this.clearTimeout();
    }

    ngAfterViewInit() {
        this.timeRange = this.getCurrentWeek();
        this.manageBookingService.getBookingList(this.timeRange).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    data['bookingList'] = this.filterData(data['bookingList']);
                    this.updateBookingListData(data);
                    this.initCalendar(this.bookingInfo);
                }
            }
        );
    }

    filterData(bookingList: Array<any>) {
        if (bookingList.length) {
            let i = 0;
            const tempArr = [];
            while (i < bookingList.length) {
                const tempId = bookingList[i].id;
                let j = 0;
                let countIds = 0;
                if (bookingList[i]['class'].indexOf('hide-text') < 0) {
                    while (j < bookingList.length) {
                        let tempIndex = -1;
                        if (tempId === bookingList[j].id) {
                            countIds++;
                            if (bookingList[i]['class'] !== 'Flu') {
                                tempIndex = i;
                            }
                        }
                        if (countIds >= 2 && tempIndex > -1) {
                            bookingList[tempIndex]['class'] += ' hide-text';
                            break;
                        }
                        j++;
                    }
                }
                i++;
            }
        }
        return bookingList;
    }

    updateBookingListData(data) {
        this.bookingInfo.bookingList = this.manageBookingService.convertBookingListToLocalTime(data.bookingList);
        this.bookingInfo.disableDates = this.manageBookingService.convertBookingDisableDateToLocalTime(data.disableDates);
    }

    initCalendar(bookingInfo) {
        let selectedEvent;
        let self = this;
        $j('#myCalendar').pagescalendar({
            ui: {
                // Year Selector
                year: {
                    visible: true,
                    format: 'YYYY',
                    startYear: (new Date()).getFullYear() - 2,
                    endYear: moment().add(1, 'year').format('YYYY'),
                    eventBubble: true
                },
                // Month Selector
                month: {
                    visible: true,
                    format: 'MMM',
                    eventBubble: true
                },
                dateHeader: {
                    format: 'dddd, D MMMM YYYY', //'MMMM YYYY, D dddd',
                    visible: true,
                },
                // Mini Week Day Selector
                week: {
                    day: {
                        format: 'D'
                    },
                    header: {
                        format: 'dd'
                    },
                    eventBubble: true,
                    startOfTheWeek: '0',
                    endOfTheWeek: '6',
                    visible: true
                },
                // Week view Grid Options
                grid: {
                    dateFormat: 'D dddd',
                    timeFormat: 'h A',
                    eventBubble: true,
                    scrollToFirstEvent: false,
                    scrollToAnimationSpeed: 300,
                    scrollToGap: 20
                }
            },
            events: bookingInfo.bookingList,
            timeFormat: 'h:mm A',
            view: 'week',
            slotDuration: '5', // 5 minutes per slot
            disableDates: bookingInfo.disableDates,
            disableTimes: bookingInfo.disableTimes,
            onViewRenderComplete: function () {
                //You can Do a Simple AJAX here and update 
            },
            onDateChange: function (range, updateViewFunction) {
                const param = {
                    startTime: self.manageBookingService.convertBookingDateToUTCString(range.start._d),
                    endTime: self.manageBookingService.convertBookingDateToUTCString(moment(range.end._d).hour(23).minute(59).second(59))
                };
                // if dateTime is in the same week then no need to reload data
                if (param.startTime === self.timeRange.startTime) {
                    return;
                }
                self.timeRange = param;
                self.manageBookingService.getBookingList(param).subscribe(
                    (result) => {
                        if (result) {
                            const data = result.json();
                            //  self.bookingInfo = data;
                            data['bookingList'] = self.filterData(data['bookingList']);
                            self.updateBookingListData(data);
                            this.events = self.bookingInfo.bookingList;
                            this.disableDates = self.bookingInfo.disableDates;
                            if (updateViewFunction && typeof (updateViewFunction) === 'function') {
                                updateViewFunction();
                            }
                        }
                    }
                );
            },
            onEventClick: function (event, updateViewFunction) {
                // open event detail popup
                if (event.bookingType == PartyType.FluVaccine && event.status === null) {
                    // if item is flu detail in flu vaccine booking then open Flu Booking detail
                    self.onOpenFluBookingDetail(event).subscribe(
                        result => {
                            if (result) {
                                const id = self.bookingInfo.bookingList[event.index].id;
                                const param = {
                                    startTime: self.manageBookingService.convertBookingDateToUTCString(event.start),
                                    endTime: self.manageBookingService.convertBookingDateToUTCString(event.end)
                                };
                                self.manageBookingService.getChildFluVaccineBooking(id, param).subscribe(
                                    (result) => {
                                        if (result) {
                                            let data = result.json();
                                            if (data) {
                                                data = self.manageBookingService.convertBookingItemToLocalTime(data);
                                                this.events[event.index] = data;
                                                if (updateViewFunction && typeof (updateViewFunction) === 'function') {
                                                    updateViewFunction();
                                                }
                                            }
                                        }
                                    }
                                );
                            }
                        });
                } else {
                    self.onOpenBookingDetail(event).subscribe(
                        result => {
                            const index = parseInt(event.index, 0);
                            if (typeof result === 'object') {
                                result = self.manageBookingService.convertBookingItemToLocalTime(result);
                                // check class hide-text and set again after update status
                                if (this.events[index]['class'].indexOf('hide-text') > -1 && result['class']) {
                                    result['class'] += ' hide-text';
                                }
                                // check if booking cancel, filter array (remove both father and child)
                                if (result['class'] === null) {
                                    const id = this.events[index].id;
                                    this.events = this.events.filter(x => x.id !== id);
                                    self.bookingInfo.bookingList = this.events;
                                } else {
                                    this.events[index] = result;
                                    self.bookingInfo.bookingList[index] = this.events[index];
                                }
                                if (updateViewFunction && typeof (updateViewFunction) === 'function') {
                                    updateViewFunction();
                                }
                            } else if (result === true) {
                                // event was delete then remove from event list
                                const id = self.bookingInfo.bookingList[index]['id'];
                                let i = 0;
                                while (i < self.bookingInfo.bookingList.length) {
                                    if (id === self.bookingInfo.bookingList[i]['id']) {
                                        this.events.splice(i, 1);
                                        self.bookingInfo.bookingList.splice(i, 1);
                                    }
                                    i++;
                                }
                                if (updateViewFunction && typeof (updateViewFunction) === 'function') {
                                    updateViewFunction();
                                }
                            }
                        },
                        error => {
                            self.dialogService.openErrorDialog({ message: error });
                        }
                    );
                }
            },

            onEventDragStart: function (event) {
            },
            onEventDragComplete: function (event, newEvent, element, callbackFunction) {
                if ($j(element).parent().hasClass('disable')) {
                    callbackFunction(event, false);
                    return;
                }
                // return true when update success, else return false
                selectedEvent = event;
                const confirmMessage = AppMessages.bookingCalendar.changeDate;
                self.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(result => {
                    if (result) {
                        const data = {
                            startTime: self.manageBookingService.convertBookingDateToUTCString(newEvent.start),
                            endTime: self.manageBookingService.convertBookingDateToUTCString(newEvent.end)
                        };
                        const id = self.bookingInfo.bookingList[event.index].id;
                        // call API to update this event
                        self.manageBookingService.changeTimeManageBooking(id, data).subscribe(
                            result1 => {
                                if (callbackFunction && typeof (callbackFunction) === 'function') {
                                    callbackFunction(event, true);
                                }
                            },
                            err => {
                                if (callbackFunction && typeof (callbackFunction) === 'function') {
                                    callbackFunction(event, false);
                                }
                            }
                        );
                    } else {
                        if (callbackFunction && typeof (callbackFunction) === 'function') {
                            callbackFunction(event, false);
                        }
                    }
                });
            },
            onEventResizeComplete: function (event, newEvent, callbackFunction) {
                selectedEvent = event;
                const confirmMessage = AppMessages.bookingCalendar.changeDate;
                self.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(result => {
                    if (result) {
                        const data = {
                            startTime: self.manageBookingService.convertBookingDateToUTCString(newEvent.start),
                            endTime: self.manageBookingService.convertBookingDateToUTCString(newEvent.end)
                        };
                        const id = self.bookingInfo.bookingList[newEvent.index].id;
                        // call API to update this event
                        self.manageBookingService.changeTimeManageBooking(id, data).subscribe(
                            result2 => {
                                if (callbackFunction && typeof (callbackFunction) === 'function') {
                                    callbackFunction(event, true);
                                }
                            },
                            err => {
                                if (callbackFunction && typeof (callbackFunction) === 'function') {
                                    callbackFunction(event, false);
                                }
                            }

                        );
                    } else {
                        if (callbackFunction && typeof (callbackFunction) === 'function') {
                            callbackFunction(event, false);
                        }
                    }
                });
            },
            onTimeSlotDblClick: function (timeSlot) {
                if (self.bookingCacheDetail == null) {
                    return;
                }
                self.clearTimeout();
                const confirmMessage = AppMessages.bookingCalendar.bookingConfirm;
                self.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(
                    confirm => {
                        if (confirm) {
                            self.bookingCacheDetail['startTime'] = self.manageBookingService.convertBookingDateToUTCString(timeSlot.date);
                            self.manageBookingService.addBooking(self.bookingCacheDetail).subscribe(
                                result => {
                                    if (result) {
                                        self.setInterval();
                                        const data = result.json();
                                        // Adding a new Event on Slot Double Click when API success
                                        let newEvent = data.result;
                                        newEvent = self.manageBookingService.convertBookingItemToLocalTime(newEvent);
                                        //  self.bookingInfo.bookingList.push(newEvent);
                                        newEvent['index'] = this.events.length - 1;
                                        self.dialogService.openSuccessDialog({ message: data.message.message });
                                        selectedEvent = newEvent;
                                        $j('#myCalendar').pagescalendar('addEvent', newEvent);
                                        self.bookingInfo.bookingList = this.events;
                                        // reset  self.bookingCacheDetail
                                        self.bookingCacheDetail = null;
                                        self.showBack = false;
                                    }
                                }
                                // error =>{
                                //     self.dialogService.openErrorDialog({message : error.message})
                                // }
                            );
                        }
                    });
            }
        });
    }

    onOpenBookingDetail(item): Observable<any> {
        const data = {
            id: this.bookingInfo.bookingList[item.index].id
        };
        const dialogRef = this.dialogService.openComponentDialog(BookingDetailsPopupComponent, data, { 'width': '900px' });
        return dialogRef;
    }

    onOpenFluBookingDetail(item): Observable<any> {
        const data = {
            id: this.bookingInfo.bookingList[item.index].id,
            startTime: this.manageBookingService.convertBookingDateToUTCString(item.start),
            endTime: this.manageBookingService.convertBookingDateToUTCString(item.end)
        };
        const dialogRef = this.dialogService.openComponentDialog(BookingDetailsFluVaccinePopupComponent, data, { 'width': '600px' });
        return dialogRef;
    }

    onAddBooking() {
        this.showDeactiveMessage = true;
        this.router.navigate(['booking/request-appointment']);
    }

    onBack() {
        // redirect to add member page
        this.showDeactiveMessage = false;
        this.router.navigate(['booking/list-member']);
    }

    getCurrentWeek(start = null, end = null) {
        const currentDay = moment().hour(0).minute(0).second(0).format('YYYY-MM-DDTHH:mm:ss');
        const dayNum = moment(currentDay).day();
        return {
            startTime: this.manageBookingService.convertBookingDateToUTCString(moment(currentDay).add('days', -dayNum)),
            endTime: this.manageBookingService.convertBookingDateToUTCString(moment(currentDay).add('days', (6 - dayNum)).hour(23).minute(59).second(59))
        };
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/manage-booking/manage-booking.component.ts